"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _area = require("@/api/area");
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'AreaMenuComponent',
  components: {
    Treeselect: _vueTreeselect.default
  },
  props: {
    systemType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['parent', 'node'].indexOf(value) !== -1;
      }
    }
  },
  data: function data() {
    return {
      // 遮罩层
      listLoading: false,
      // 显示搜索条件
      showSearch: true,
      // 菜单表格树数据
      menuList: [],
      // 菜单树选项
      menuOptions: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 重新渲染表格状态
      refreshTable: true,
      // 查询参数
      queryParams: {
        name: '',
        menuType: '',
        systemType: '' // 初始化为空字符串，避免this.systemType未定义
      },
      name: '',
      // 表单参数
      form: {},
      //请求到的menu数据
      menuDataList: [],
      // 表单校验
      rules: {
        name: [{
          required: true,
          message: '菜单名称不能为空',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '菜单顺序不能为空',
          trigger: 'blur'
        }]
      },
      statusOptions: [{
        value: 'M',
        label: '目录'
      }, {
        value: 'C',
        label: '菜单'
      }, {
        value: 'A',
        label: '按钮'
      }],
      showStatus: [{
        label: '显示',
        value: true
      }, {
        label: '隐藏',
        value: false
      }]
    };
  },
  created: function created() {
    // 在created中初始化systemType，确保props已经传递
    this.queryParams.systemType = this.systemType;
  },
  mounted: function mounted() {
    // 在mounted中调用getList，确保组件完全初始化后再调用API
    if ((0, _permission.checkPermi)(['platform:circle:menu:list'])) {
      this.getList();
    }
  },
  watch: {
    systemType: {
      handler: function handler(newVal, oldVal) {
        // 只有当systemType真正发生变化时才更新和调用API
        if (newVal !== oldVal && newVal) {
          this.queryParams.systemType = newVal;
          if ((0, _permission.checkPermi)(['platform:circle:menu:list'])) {
            this.getList();
          }
        }
      },
      immediate: false // 移除immediate，避免重复调用
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 点击图标
    addIcon: function addIcon() {
      var _this = this;
      _this.$modalIcon(function (icon) {
        _this.form.icon = icon;
      });
    },
    /** 查询菜单列表 */getList: function getList() {
      var _this2 = this;
      // 防止重复调用
      if (this.listLoading) {
        return;
      }

      // 确保systemType存在
      if (!this.systemType) {
        console.warn('AreaMenuComponent: systemType is required');
        return;
      }
      this.listLoading = true;
      this.queryParams.name = encodeURIComponent(this.name || '');
      // 确保systemType参数被传递
      this.queryParams.systemType = this.systemType;
      (0, _area.menuAreaListApi)(this.queryParams).then(function (res) {
        var obj = {},
          menuList = [];
        if (res && Array.isArray(res)) {
          res.forEach(function (item) {
            obj = _objectSpread({}, item); // 使用展开运算符避免引用问题
            obj.parentId = item.pid;
            obj.children = [];
            menuList.push(obj);
          });
        }
        _this2.menuDataList = menuList;
        _this2.menuList = _this2.handleTree(menuList, 'menuId');
        _this2.getTreeselect();
        _this2.listLoading = false;
      }).catch(function (error) {
        console.error('AreaMenuComponent getList error:', error);
        _this2.listLoading = false;
        _this2.$modal.msgError('获取菜单列表失败');
      });
    },
    /** 转换菜单数据结构 */normalizer: function normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id ? node.id : 0,
        label: node.name ? node.name : '主目录',
        children: node.children
      };
    },
    /** 查询菜单下拉树结构 */getTreeselect: function getTreeselect() {
      this.menuOptions = [];
      var menu = {
        menuId: 0,
        menuName: '主类目',
        children: []
      };
      menu.children = this.handleTree(this.menuDataList, 'menuId');
      this.menuOptions.push(menu);
    },
    // 取消按钮
    cancel: function cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset: function reset() {
      this.form = {
        menuId: '',
        parentId: 0,
        name: '',
        icon: '',
        menuType: 'M',
        sort: 0,
        isShow: true,
        component: '',
        perms: '',
        systemType: this.systemType // 添加systemType到表单
      };
    },
    /** 搜索按钮操作 */handleQuery: function handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */resetQuery: function resetQuery() {
      var _this3 = this;
      this.name = '';
      this.queryParams = {
        name: '',
        menuType: '',
        systemType: this.systemType // 重置时保持systemType
      };
      // 使用$nextTick确保DOM更新后再调用API
      this.$nextTick(function () {
        _this3.handleQuery();
      });
    },
    /** 新增按钮操作 */handleAdd: function handleAdd(row) {
      this.reset();
      if (row != null && row.id) {
        this.form.pid = row.id;
      } else {
        this.form.pid = 0;
      }
      this.open = true;
      this.title = '添加菜单';
      this.getTreeselect();
    },
    /** 展开/折叠操作 */toggleExpandAll: function toggleExpandAll() {
      var _this4 = this;
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(function () {
        _this4.refreshTable = true;
      });
    },
    /** 修改按钮操作 */handleUpdate: function handleUpdate(row) {
      var _this5 = this;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      this.reset();
      this.getTreeselect();
      (0, _area.menuAreaInfo)(row.id).then(function (response) {
        _this5.form = response;
        _this5.form.systemType = _this5.systemType; // 确保systemType被设置
        _this5.open = true;
        _this5.title = '修改菜单';
        loading.close();
      });
    },
    /** 提交按钮 */
    submitForm: (0, _validate.Debounce)(function () {
      var _this6 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 确保提交时包含systemType
          _this6.form.systemType = _this6.systemType;
          if (_this6.form.id != undefined) {
            (0, _area.menuAreaUpdate)(_this6.form).then(function (response) {
              _this6.$modal.msgSuccess('修改成功');
              _this6.open = false;
              _this6.getList();
            });
          } else {
            (0, _area.menuAreaAdd)(_this6.form).then(function (response) {
              _this6.$modal.msgSuccess('新增成功');
              _this6.open = false;
              _this6.getList();
            });
          }
        }
      });
    }),
    /** 删除按钮操作 */handleDelete: function handleDelete(row) {
      var _this7 = this;
      this.$modal.confirm('是否确认删除名称为"' + row.name + '"的数据项？').then(function () {
        return (0, _area.menuAreaDelete)(row.id);
      }).then(function () {
        _this7.getList();
        _this7.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    }
  }
};